export default __webpack_public_path__ + "static/media/rabbit.3603e99c.png";